export const campaigns = (state) => {
    return state.campaigns;
};
